import { Box } from "@mui/material";
import { GridRenderCellParams, useGridApiContext, useGridSelector, gridFilteredDescendantCountLookupSelector } from "@mui/x-data-grid-pro";

const CustomGridTreeDataGroupingCell = (props: GridRenderCellParams) => {
    const { id, field, rowNode, row } = props;
    const apiRef = useGridApiContext();
    const filteredDescendantCountLookup = useGridSelector(
        apiRef,
        gridFilteredDescendantCountLookupSelector,
    );
    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

    if (filteredDescendantCount > 0 || !row.resourceId) {
        return (
            <Box sx={{ ml: rowNode.depth * 4 }}>
                <div>
                    {apiRef.current.getCellValue(rowNode.id, field)}
                </div>
            </Box>
        );
    }
    return null;
}

export default CustomGridTreeDataGroupingCell;